import React from 'react';
import { Message as MessageType } from '../types';
import AssistantIcon from './AssistantIcon';
import LoadingSpinner from './LoadingSpinner';
import OfferCarousel from './OfferCarousel';
import WelcomeScreen from './WelcomeScreen';
import { FeedbackComponent } from './FeedbackComponent';
import { useTranslation } from '../hooks/useTranslation';

interface MessageProps {
  message: MessageType;
  currency?: string;
  language?: string;
  user?: any;
  sessionId?: string;
  onTrendingPromptClick?: (prompt: string) => void;
  onSignupClick?: () => void;
}

const Message: React.FC<MessageProps> = React.memo(({ message, currency, language, user, sessionId, onTrendingPromptClick, onSignupClick }) => {
  const { t } = useTranslation(language);
  const isAssistant = message.role === 'assistant';
  const isUser = message.role === 'user';
  const showFeedback = isAssistant && !message.isLoading && !message.isWelcome && !message.isThinking;

  return (
    <div 
      className={`message ${message.role} ${message.isThinking ? 'thinking flash' : ''}`} 
      data-message-id={message.id}
    >
      {isAssistant && <AssistantIcon />}

      <div className="message-content-wrapper">
        <div className="message-content">
          {message.isWelcome ? (
            <WelcomeScreen 
              language={language || 'en'}
              user={user}
              onSignupClick={onSignupClick || (() => {})}
            />
          ) : message.isComponent ? (
            message.content
          ) : message.isLoading ? (
            <LoadingSpinner />
          ) : message.isCarousel ? (
            <OfferCarousel offers={message.carouselData || []} currency={currency} language={language} user={user} />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: message.content as string }} />
          )}
        </div>
        {showFeedback && sessionId && (
          <div className="message-feedback">
            <FeedbackComponent 
              sessionId={sessionId}
              messageId={message.id}
              language={language}
            />
          </div>
        )}
      </div>
    </div>
  );
});

Message.displayName = 'Message';

export default Message;
